// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectorStyle_selector__qCvYk {
  font-weight: bold !important;
}

@media (max-width: 600px) {
  .selectorStyle_selector__qCvYk {
    font-size: 0.8em !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/jss/material-dashboard-pro-react/creativeTim/views/selectorStyle.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".selector {\n  font-weight: bold !important;\n}\n\n@media (max-width: 600px) {\n  .selector {\n    font-size: 0.8em !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `selectorStyle_selector__qCvYk`
};
export default ___CSS_LOADER_EXPORT___;
